export const API_BASEURL = process.env.REACT_APP_API_BASEURL;
export const GRAPH_NODE_BASEURL = process.env.REACT_APP_GRAPH_NODE_BASEURL;
export const GRAPH_QUERY_BASEURL = process.env.REACT_APP_GRAPH_QUERY_BASEURL;
export const GRAPH_IPFS_BASEURL = process.env.REACT_APP_GRAPH_IPFS_BASEURL;
export const GRAPH_V2_NODE_BASEURL = process.env.REACT_APP_GRAPH_V2_NODE_BASEURL;
export const GRAPH_V2_QUERY_BASEURL = process.env.REACT_APP_GRAPH_V2_QUERY_BASEURL;
export const GRAPH_V2_IPFS_BASEURL = process.env.REACT_APP_GRAPH_V2_IPFS_BASEURL;
export const GITHUB_CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID;
export const GITHUB_OAUTH_LOGIN_BASEURL = `https://github.com/login/oauth/authorize`;
export const GITHUB_OAUTH_ACCESS_TOKEN_BASEURL = `https://github.com/login/oauth/access_token`;
export const SUPPORT_NETWORK = [
  { name: "Cronos Mainnet", value: "cronos" },
  { name: "Cronos Testnet", value: "cronos-testnet" },
];
